import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { numberConvert } from "@website/utils/number-convert";
import { useEffect } from "react";
export const useCounterButton = properties => {
  const $ = _c(35);
  const {
    color,
    decreaseDisabled,
    increaseDisabled,
    onChange,
    value: t0,
    variant,
    locale,
    "aria-label": ariaLabel
  } = properties;
  const value = t0 === undefined ? 0 : t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = () => {
      onChange?.(value - 1);
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDecreaseButtonClick = t1;
  let t2;
  if ($[3] !== onChange || $[4] !== value) {
    t2 = () => {
      onChange?.(value + 1);
    };
    $[3] = onChange;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onIncreaseButtonClick = t2;
  let t3;
  let t4;
  if ($[6] !== onChange || $[7] !== value) {
    t3 = () => {
      if (value === undefined) {
        onChange?.(0);
      }
    };
    t4 = [onChange, value];
    $[6] = onChange;
    $[7] = value;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  const t5 = value || 0;
  const t6 = locale || "en";
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = numberConvert(t5, {
      locale: t6
    });
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = ariaLabel ? `${"\u06A9\u0627\u0647\u0634"} ${ariaLabel}` : "decrease button";
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MaterialIcon name="remove" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== color || $[16] !== decreaseDisabled || $[17] !== onDecreaseButtonClick || $[18] !== t9 || $[19] !== variant) {
    t11 = {
      "aria-label": t9,
      color,
      disabled: decreaseDisabled,
      EndIcon: t10,
      onClick: onDecreaseButtonClick,
      equalDimension: true,
      variant
    };
    $[15] = color;
    $[16] = decreaseDisabled;
    $[17] = onDecreaseButtonClick;
    $[18] = t9;
    $[19] = variant;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = ariaLabel || undefined;
  let t13;
  if ($[21] !== t12) {
    t13 = {
      "aria-label": t12
    };
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = ariaLabel ? `${"\u0627\u0641\u0632\u0627\u06CC\u0634"} ${ariaLabel}` : "increase button";
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MaterialIcon name="add" />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== color || $[25] !== increaseDisabled || $[26] !== onIncreaseButtonClick || $[27] !== t14 || $[28] !== variant) {
    t16 = {
      "aria-label": t14,
      color,
      disabled: increaseDisabled,
      EndIcon: t15,
      onClick: onIncreaseButtonClick,
      equalDimension: true,
      variant
    };
    $[24] = color;
    $[25] = increaseDisabled;
    $[26] = onIncreaseButtonClick;
    $[27] = t14;
    $[28] = variant;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t11 || $[31] !== t13 || $[32] !== t16 || $[33] !== t7) {
    t17 = {
      value: t7,
      rootProps: t8,
      decreaseButtonProps: t11,
      valueProps: t13,
      increaseButtonProps: t16
    };
    $[30] = t11;
    $[31] = t13;
    $[32] = t16;
    $[33] = t7;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};